import { createApp } from 'vue'
import CV from './cv.vue'

const app = createApp(CV)
app.mount('#app')
